import {
  Dialog,
  Slider,
  SliderOutput,
  SliderThumb,
  SliderTrack,
} from "react-aria-components";
import { SizedContainer } from "../sizedContainer.js";

interface VolumeDialogProps {
  volume: number;
  onVolumeChange: (value: number) => void;
}

export function VolumeDialog({ volume, onVolumeChange }: VolumeDialogProps) {
  return (
    <Dialog className="p-2">
      <Slider
        className="flex flex-col items-center"
        aria-label="Volume"
        orientation="vertical"
        value={volume}
        minValue={0}
        maxValue={1}
        step={0.01}
        onChange={onVolumeChange}
        formatOptions={{
          style: "percent",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }}
      >
        <SliderTrack className="group relative my-[7.5px] h-40 w-full">
          {({ state }) => (
            <>
              <div className="absolute top-0 bottom-0 left-[50%] w-[5px] translate-x-[-50%] rounded-full bg-gray-300" />
              <div
                className="absolute bottom-0 left-[50%] w-[5px] translate-x-[-50%] rounded-full bg-primary"
                style={{
                  height: (state.getThumbPercent(0) * 100).toFixed(1) + "%",
                }}
              />
              <SliderThumb
                className="left-[50%] size-[13px] rounded-full bg-primary ring-indigo-600 ring-offset-2 outline-hidden focus-visible:ring-2"
                autoFocus
              />
            </>
          )}
        </SliderTrack>
        <SizedContainer
          className="text-center text-xs text-foreground"
          childrenForSize="100%"
        >
          <SliderOutput />
        </SizedContainer>
      </Slider>
    </Dialog>
  );
}
